import { ColorEnum } from '@/constants/color'
import { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const MobileIcon: FC<SvgProps> = (props) => {
    return (
        <Svg viewBox="0 0 16 16" height={16} width={16} {...props}>
            <Path
                fill={ColorEnum.EMERALD_500}
                d="M4.465 15.317c-.389 0-.716-.133-.983-.4a1.337 1.337 0 0 1-.4-.983V2.067c0-.389.133-.717.4-.983.267-.267.594-.4.983-.4h7.067c.39 0 .717.133.984.4.266.266.4.594.4.983v11.867c0 .389-.134.716-.4.983-.267.267-.595.4-.984.4H4.465Zm0-3.783v2.4h7.067v-2.4H4.465ZM8 13.334a.593.593 0 0 0 .425-.167.55.55 0 0 0 .175-.416.6.6 0 0 0-1.025-.443.58.58 0 0 0-.175.426c0 .166.058.308.175.425a.578.578 0 0 0 .425.175Zm-3.534-3h7.067V4.067H4.465v6.267Zm0-7.467h7.067v-.8H4.465v.8Z"
            />
        </Svg>
    )
}

export default MobileIcon
